const $ = jQuery;

export default {
    init() {
        setupCaseStudyFilters();
    }
};

function setupCaseStudyFilters() {
    const $blocks = $('.block-case-study-archive');

    if (!$blocks.length) return;

    $blocks.each(function() {
        const $container = $(this);
        const $filters = $container.find('.filter-btn');
        const $items = $container.find('.case-study-item');

        const filterGrid = (category, targetHref) => {
            $filters.removeClass('active bg-black text-white').addClass('bg-gray-100 text-gray-600');
            $filters.filter(`[data-filter="${category}"]`).removeClass('bg-gray-100 text-gray-600').addClass('active bg-black text-white');

            $items.each(function() {
                const $item = $(this);
                const itemCats = JSON.parse($item.attr('data-category') || '[]');

                if (category === 'all' || itemCats.includes(category)) {
                    $item.removeClass('hidden').addClass('flex');
                } else {
                    $item.removeClass('flex').addClass('hidden');
                }
            });

            if (targetHref) {
                window.history.pushState({}, '', targetHref);
            }
        };

        $filters.on('click', function(e) {
            e.preventDefault();
            const $btn = $(this);
            filterGrid($btn.data('filter'), $btn.attr('href'));
        });

        const initialCategory = $filters.filter('.active').data('filter') || 'all';
        if (initialCategory !== 'all') {
            filterGrid(initialCategory, null);
        }
    });
}
